var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"appear","mode":"out-in"}},[(_vm.isVisible)?_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"}],staticClass:"raise",attrs:{"title":"Наверх"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }